module.exports = __webpack_public_path__ + "img/about13.51758fb2.jpg";